import React from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

const Wrap = styled(Flex)`
  gap: 8px;
`
const WrapCopy = styled(Flex)`
  gap: 16px;

  .icon-br {
    @media (min-width: 500px) and (max-width: 1023px) {
      display: none;
    }
  }

  svg {
    margin: 0 auto;
    width: 40px;
    height: 40px;
    @media (min-width: 1024px) {
      width: 48px;
      height: 48px;
    }
  }
`

const Icons = ({ data }) => {
  return (
    <Wrap
      flexDirection={["row"]}
      justifyContent={[null, null, null, "space-between"]}
    >
      {data.map((item, index) => {
        return (
          <WrapCopy
            key={index}
            flexDirection={["column", null, null, null, "row"]}
            width={[1, 1, 1, 1, "fit-content"]}
            mx="auto"
            alignItems="center"
          >
            <Box width={[1, 1, 1, 48, 48]}>
              <item.iconMobile />
            </Box>
            <Box flex="1" maxWidth={[null, null, null, 110, 200]}>
              <TextElementNova
                text={item.title}
                classes={{
                  default: "Body-10-Dia-Normal",
                  768: "Body-10-Dia-Normal",
                  1024: "Body-20-Dia-Normal",
                }}
                className="text-nova-base-black text-center lg:text-left"
              />
            </Box>
          </WrapCopy>
        )
      })}
    </Wrap>
  )
}

export default Icons
